/**
 * Class representing a CNPJ validator.
 *
 * @author Maria Eduarda Franke
 * @class CNPJValidador
 * @static
 */
export default class CNPJValidador {

    static mullArr = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    /**
    * Validates a CNPJ (Brazilian company registration number).
    *
    * @author Maria Eduarda Franke
    * @param {string} value - The CNPJ to be validated.
    * @returns {boolean} - True if the CNPJ is valid, false otherwise.
    */
    static validate(value) {

        const cnpj = value.replace(/\D/g, '')

        if (!cnpj || typeof cnpj !== 'string')
            return false

        if (cnpj.length !== 14 || !RegExp(/^\d*$/).exec(cnpj))
            return false

        const digits = cnpj.split('').map(Number)

        if (digits.every(d => digits[0] === d))
            return false

        if (CNPJValidador.getDigit(digits) !== digits[digits.length - 2])
            return false

        return CNPJValidador.getDigit(digits, 0) === digits[digits.length - 1]
    }

    /**
    * Calculates the verification digit for a given array of digits.
    *
    * @author Maria Eduarda Franke
    * @param {number[]} digits - The array of digits.
    * @param {number} [offset=1] - The offset to start the calculation from.
    * @returns {number} - The calculated verification digit.
    */
    static getDigit(digits, offset = 1) {
        let sum = 0

        for (let i = offset; i < CNPJValidador.mullArr.length; i++)
            sum += digits[i - offset] * CNPJValidador.mullArr[i]

        let div = sum % 11

        return div < 2 ? 0 : 11 - div
    }
}
